module.exports = __webpack_public_path__ + "img/5.10a1b01e.svg";